<template>
  <b-button
    v-if="!isExternalLink"
    @click="$emit('click', $event)"
    :to="link"
    :target="target"
    :variant="variant"
    :aria-label="title"
    :title="tooltip ? null : title"
    :class="extraClass + (icon ? ' btn-icon' : '')"
    class="btn btn-light-primary btn-xs p-0 ml-1"
    :disabled="disabled"
  >
    <component v-if="icon" :is="icon" :size="iconSize" />
    <div v-else class="btn-text">
      <slot />
    </div>
  </b-button>
  <a v-else :target="target" :href="link">
    <b-button
      @click="$emit('click', $event)"
      :variant="variant"
      :aria-label="title"
      :title="tooltip ? null : title"
      :class="extraClass + (icon ? ' btn-icon' : '')"
      class="btn btn-light-primary btn-xs p-0 ml-1"
      :disabled="disabled"
    >
      <component v-if="icon" :is="icon" :size="iconSize" />
      <slot />
    </b-button>
  </a>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    // Lucide-Icon als Komponente
    icon: {
      type: [Object, Function],
      default: null,
    },
    iconSize: {
      type: Number,
      default: 14,
    },
    extraClass: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'secondary',
    },
    title: {
      type: String,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    link: {
      type: [Object, String],
      default: null,
    },
    target: {
      type: String,
      default: '_blank',
    },
  },

  computed: {
    isExternalLink() {
      return typeof this.link === 'string' && this.link.startsWith('http');
    },
  },
};
</script>

<style scoped lang="scss">
.btn > .btn-text {
  padding: 1px 0.5rem;
}
</style>
